import type { Modul, Route } from "./modul";

/** Alle Routen aus dem Modulregister. Bei gleichem Pfad gewinnt das spätere Modul (zum Beispiel ersetzt „aufgaben“ die Startseite des Kerns). */
export function routenAus(module: readonly Modul[]): Route[] {
  const nachPfad = new Map<string, Route>();
  for (const m of module) for (const r of m.routen) nachPfad.set(r.pfad, r);
  return [...nachPfad.values()];
}
